module.exports = __webpack_public_path__ + "img/gb879-86-4x26.prt.78549f0b.jpg";